import {
  ColumnDetail,
  ComplexSelectionFormValue,
  RowDetail,
} from '../../../../../../../../../../ui/gzSelectableTableRowGroup/types';
import {
  AntimalwareAntiExploitDetectionTechniques,
  AntimalwareAntiExploitDetectionTechniquesName,
  AntimalwareAntiExploitSystemWideDetectionsLinuxAction,
} from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';

export enum AntimalwareAntiExploitDetectionTechniquesKey {
  ROP_EMULATION = 'ropEmulation',
  ROP_STACK_PIVOT = 'ropStackPivot',
  ROP_ILLEGAL_CALL = 'ropIllegalCall',
  ROP_STACK_MISALIGNED = 'ropStackMisaligned',
  ROP_RETURN_TO_STACK = 'ropReturnToStack',
  ROP_MAKE_STACK_EXECUTABLE = 'ropMakeStackExecutable',
  FLASH_GENERIC = 'flashGeneric',
  SHELLCODE_EXECUTION = 'shellcodeExecution',
  SHELLCODE_LOADLIBRARY_UNC = 'shellcodeLoadLibraryUnc',
  ANTI_DETOUR = 'antiDetour',
  FLASH_PAYLOAD = 'flashPayload',
  ROP_CREATE_THREAD = 'ropCreateThread',
  ANTI_METERPRETER = 'antiMeterpreter',
  OBSOLETE_PROCESS_CREATION = 'obsoleteProcessCreation',
  CHILD_PROCESS_CREATION = 'childProcessCreation',
  ENFORCE_WINDOWS_DEP = 'enforceWindowsDep',
  ENFORCE_MODULE_RELOCATION = 'enforceModuleRelocation',
  VBSCRIPT_GENERIC = 'vbscriptGeneric',
  SHELLCODE_EAF = 'shellcodeEaf',
  EMERGING_EXPLOITS = 'emergingExploits',
}

function getKeyByName() {
  return {
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_EMULATION]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_EMULATION,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_STACK_PIVOT]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_PIVOT,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_ILLEGAL_CALL]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_ILLEGAL_CALL,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_STACK_MISALIGNED]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_MISALIGNED,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_RETURN_TO_STACK]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_RETURN_TO_STACK,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_MAKE_STACK_EXECUTABLE]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_MAKE_STACK_EXECUTABLE,
    [AntimalwareAntiExploitDetectionTechniquesName.FLASH_GENERIC]:
      AntimalwareAntiExploitDetectionTechniquesKey.FLASH_GENERIC,
    [AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_EXECUTION]:
      AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EXECUTION,
    [AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_LOADLIBRARY_UNC]:
      AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_LOADLIBRARY_UNC,
    [AntimalwareAntiExploitDetectionTechniquesName.ANTI_DETOUR]:
      AntimalwareAntiExploitDetectionTechniquesKey.ANTI_DETOUR,
    [AntimalwareAntiExploitDetectionTechniquesName.FLASH_PAYLOAD]:
      AntimalwareAntiExploitDetectionTechniquesKey.FLASH_PAYLOAD,
    [AntimalwareAntiExploitDetectionTechniquesName.ROP_CREATE_THREAD]:
      AntimalwareAntiExploitDetectionTechniquesKey.ROP_CREATE_THREAD,
    [AntimalwareAntiExploitDetectionTechniquesName.ANTI_METERPRETER]:
      AntimalwareAntiExploitDetectionTechniquesKey.ANTI_METERPRETER,
    [AntimalwareAntiExploitDetectionTechniquesName.OBSOLETE_PROCESS_CREATION]:
      AntimalwareAntiExploitDetectionTechniquesKey.OBSOLETE_PROCESS_CREATION,
    [AntimalwareAntiExploitDetectionTechniquesName.CHILD_PROCESS_CREATION]:
      AntimalwareAntiExploitDetectionTechniquesKey.CHILD_PROCESS_CREATION,
    [AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_WINDOWS_DEP]:
      AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_WINDOWS_DEP,
    [AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_MODULE_RELOCATION]:
      AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_MODULE_RELOCATION,
    [AntimalwareAntiExploitDetectionTechniquesName.VBSCRIPT_GENERIC]:
      AntimalwareAntiExploitDetectionTechniquesKey.VBSCRIPT_GENERIC,
    [AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_EAF]:
      AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EAF,
    [AntimalwareAntiExploitDetectionTechniquesName.EMERGING_EXPLOITS]:
      AntimalwareAntiExploitDetectionTechniquesKey.EMERGING_EXPLOITS,
  };
}

function getNameByKey() {
  return {
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_EMULATION]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_EMULATION,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_PIVOT]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_STACK_PIVOT,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_ILLEGAL_CALL]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_ILLEGAL_CALL,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_MISALIGNED]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_STACK_MISALIGNED,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_RETURN_TO_STACK]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_RETURN_TO_STACK,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_MAKE_STACK_EXECUTABLE]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_MAKE_STACK_EXECUTABLE,
    [AntimalwareAntiExploitDetectionTechniquesKey.FLASH_GENERIC]:
      AntimalwareAntiExploitDetectionTechniquesName.FLASH_GENERIC,
    [AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EXECUTION]:
      AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_EXECUTION,
    [AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_LOADLIBRARY_UNC]:
      AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_LOADLIBRARY_UNC,
    [AntimalwareAntiExploitDetectionTechniquesKey.ANTI_DETOUR]:
      AntimalwareAntiExploitDetectionTechniquesName.ANTI_DETOUR,
    [AntimalwareAntiExploitDetectionTechniquesKey.FLASH_PAYLOAD]:
      AntimalwareAntiExploitDetectionTechniquesName.FLASH_PAYLOAD,
    [AntimalwareAntiExploitDetectionTechniquesKey.ROP_CREATE_THREAD]:
      AntimalwareAntiExploitDetectionTechniquesName.ROP_CREATE_THREAD,
    [AntimalwareAntiExploitDetectionTechniquesKey.ANTI_METERPRETER]:
      AntimalwareAntiExploitDetectionTechniquesName.ANTI_METERPRETER,
    [AntimalwareAntiExploitDetectionTechniquesKey.OBSOLETE_PROCESS_CREATION]:
      AntimalwareAntiExploitDetectionTechniquesName.OBSOLETE_PROCESS_CREATION,
    [AntimalwareAntiExploitDetectionTechniquesKey.CHILD_PROCESS_CREATION]:
      AntimalwareAntiExploitDetectionTechniquesName.CHILD_PROCESS_CREATION,
    [AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_WINDOWS_DEP]:
      AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_WINDOWS_DEP,
    [AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_MODULE_RELOCATION]:
      AntimalwareAntiExploitDetectionTechniquesName.ENFORCE_MODULE_RELOCATION,
    [AntimalwareAntiExploitDetectionTechniquesKey.VBSCRIPT_GENERIC]:
      AntimalwareAntiExploitDetectionTechniquesName.VBSCRIPT_GENERIC,
    [AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EAF]:
      AntimalwareAntiExploitDetectionTechniquesName.SHELLCODE_EAF,
    [AntimalwareAntiExploitDetectionTechniquesKey.EMERGING_EXPLOITS]:
      AntimalwareAntiExploitDetectionTechniquesName.EMERGING_EXPLOITS,
  };
}

export const columns = (): ColumnDetail<AntimalwareAntiExploitSystemWideDetectionsLinuxAction>[] => {
  return [
    {
      column: AntimalwareAntiExploitSystemWideDetectionsLinuxAction.REPORT_ONLY,
      label: translateFn('Report only'),
    },
    {
      column: AntimalwareAntiExploitSystemWideDetectionsLinuxAction.KILL_PROCESS,
      label: translateFn('Kill process'),
    },
  ];
};

export const rows = (): RowDetail<
  AntimalwareAntiExploitDetectionTechniquesKey,
  AntimalwareAntiExploitSystemWideDetectionsLinuxAction
>[] => [
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_EMULATION,
    label: translateFn('ROP Emulation'),
    tooltip: translateFn('Detects attempts to mark data memory pages as executable using the ROP technique.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_PIVOT,
    label: translateFn('ROP Stack Pivot'),
    tooltip: translateFn(
      'Detects attempts to hijack the code flow using the ROP technique, by validating stack location.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_ILLEGAL_CALL,
    label: translateFn('ROP Illegal Call'),
    tooltip: translateFn(
      'Detects attempts to hijack the code flow using the ROP technique, by validating callers of sensitive system functions.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_STACK_MISALIGNED,
    label: translateFn('ROP Stack Misaligned'),
    tooltip: translateFn(
      'Detects attempts to corrupt the stack using the ROP technique, by validating the stack address alignment.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_RETURN_TO_STACK,
    label: translateFn('ROP Return To Stack'),
    tooltip: translateFn(
      'Detects attempts to execute code directly on stack using the ROP technique, by validating return address range.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_MAKE_STACK_EXECUTABLE,
    label: translateFn('ROP Make Stack Executable'),
    tooltip: translateFn(
      'Detects attempts to corrupt the stack using the ROP technique, by validating the stack page protection.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.FLASH_GENERIC,
    label: translateFn('Flash Generic'),
    tooltip: translateFn('Detects Flash Player exploitation attempts.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EXECUTION,
    label: translateFn('Shellcode Execution'),
    tooltip: translateFn('Detects attempts to create new processes or download files, using shellcode.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_LOADLIBRARY_UNC,
    label: translateFn('Shellcode LoadLibrary UNC'),
    tooltip: translateFn('Detects attempts to execute code via network paths, using shellcode.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ANTI_DETOUR,
    label: translateFn('Anti-detour'),
    tooltip: translateFn('Detects attempts to bypass security checks for creating new processes.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.FLASH_PAYLOAD,
    label: translateFn('Flash Payload'),
    tooltip: translateFn(
      'Detects attempts to execute malicious code into Flash Player, by scanning Flash objects in memory.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ROP_CREATE_THREAD,
    label: translateFn('Shellcode Thread'),
    tooltip: translateFn('Detects attempts to inject malicious code, by validating newly-created threads.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ANTI_METERPRETER,
    label: translateFn('Anti-meterpreter'),
    tooltip: translateFn('Detects attempts to create a reverse shell, by scanning executable memory pages.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.OBSOLETE_PROCESS_CREATION,
    label: translateFn('Obsolete Process Creation'),
    tooltip: translateFn('Detects attempts to create new processes using obsolete techniques.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.CHILD_PROCESS_CREATION,
    label: translateFn('Child Process Creation'),
    tooltip: translateFn('Blocks the creation of child processes (not recommended).'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.VBSCRIPT_GENERIC,
    label: translateFn('VBScript Generic'),
    tooltip: translateFn('Detects VBScript exploitation attempts.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.SHELLCODE_EAF,
    label: translateFn('Shellcode EAF (Export Address Filtering)'),
    tooltip: translateFn('Detects attempts of malicious code to access sensitive system functions from DLL exports.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.EMERGING_EXPLOITS,
    label: translateFn('Emerging Exploits'),
    tooltip: translateFn(
      'Protects against any new emerging threats or exploits. Rapid updates are used for this category before more comprehensive changes can be made.'
    ),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_WINDOWS_DEP,
    label: translateFn('Enforce Windows DEP'),
    availableColumns: [],
    tooltip: translateFn('Enforces Data Execution Prevention (DEP) to block code execution from data pages.'),
  },
  {
    key: AntimalwareAntiExploitDetectionTechniquesKey.ENFORCE_MODULE_RELOCATION,
    label: translateFn('Enforce Module Relocation (ASLR)'),
    availableColumns: [],
    tooltip: translateFn('Prevents code from loading at predictable memory locations by randomizing memory layout.'),
  },
];

export function convertDbValueToFormValue(
  categories: AntimalwareAntiExploitDetectionTechniques[],
  enforcedColumnValue?: AntimalwareAntiExploitSystemWideDetectionsLinuxAction
): ComplexSelectionFormValue<
  AntimalwareAntiExploitDetectionTechniquesKey,
  AntimalwareAntiExploitSystemWideDetectionsLinuxAction
> {
  const keyByName = getKeyByName();
  const uiValue = {};

  categories.forEach(category => {
    uiValue[keyByName[category.name]] = {
      // use key instead of name
      enabled: category.enable,
      column: enforcedColumnValue ?? category.action,
    };
  });

  return uiValue;
}

export function convertFormValueToDbValue(
  categories: ComplexSelectionFormValue<
    AntimalwareAntiExploitDetectionTechniquesKey,
    AntimalwareAntiExploitSystemWideDetectionsLinuxAction
  >
): AntimalwareAntiExploitDetectionTechniques[] {
  const nameByKey = getNameByKey();
  const dbValue: AntimalwareAntiExploitDetectionTechniques[] = [];

  Object.entries(categories).forEach(([key, value]) => {
    dbValue.push({
      name: nameByKey[key], // convert key to name
      enable: value.enabled,
      action: value.column,
    });
  });

  return dbValue;
}
